/* eslint-disable sonarjs/no-duplicate-string */
define((require) => {
    'use strict';

    require('toolkit/b-toolkit/b-toolkit');
    require('mrg-form/b-form/b-form');
    require('toolkit/b-controls-group/b-controls-group');

    const $ = require('jQuery');

    const BLayer = require('toolkit/b-layer/b-layer');

    return BLayer.extend('form-layer', {
        inner: true,
        renderMode: 'replace',
        service: true,
        width: 680,

        _initDropdowns() {},

        init() {
            this.templateBlock = 'b-layer';

            // eslint-disable-next-line prefer-rest-params
            BLayer.fn.init.apply(this, arguments);
        },

        hasValidForm() {
            return this._form && this._form.validate();
        },

        onBeforeAccept() {
            if (this.hasValidForm()) {
                this.emit('accept', this.getFormData());
            }
        },

        onRender() {
            this._form = this.$('form').getBlock();

            this._form.getFields().forEach((field) => {
                field.on('changeFormValue', () => {
                    this.emit('change', [field]);
                    this.emit('change:' + field.name, [field]);
                });

                if (field.input) {
                    field.input.on('focus', () => {
                        this.emit('focus:' + field.name, [field]);
                    });

                    field.input.on('blur', () => {
                        this.emit('blur:' + field.name, [field]);
                    });
                }
            });
        },

        showErrors(errors) {
            this._form.showErrors(errors);
        },

        toggleFormError(error, state, text) {
            this._form.toggleFormError(error, state, text);
        },

        disable() {
            this._form.toggleMod('disabled', true);
        },

        enable() {
            this._form.toggleMod('disabled', false);
        },

        getFormData() {
            return this._form.getFormData();
        },

        getFields() {
            return this._form.getFields();
        },

        getField(name) {
            return this._form.getField(name);
        },

        _getFields() {
            if (typeof this.fields === 'function') {
                this.fields = this.fields(this.data);
            }

            return this.fields.map((field) => {
                field = Object.assign({}, field);

                field.mods = ['responsive', 'compact'].concat(
                    field.mods,
                    this.mods || [],
                );

                if (field.columns) {
                    field.columns.forEach(function(field) {
                        if (!field.errors) {
                            field.errors = [];
                        }

                        field.mods = ['responsive', 'compact'].concat(
                            field.mods,
                            this.mods || [],
                        );

                        field.errors.push = {
                            type: 'custom',
                            text: '',
                        };
                    }, this);
                } else {
                    if (!field.errors) {
                        field.errors = [];
                    }

                    field.errors.push = {
                        type: 'custom',
                        text: '',
                    };
                }

                return field;
            });
        },

        _getErrors() {
            let errors = this.errors;

            if (!errors) {
                errors = [];
            }

            errors.push = {
                type: 'custom',
                text: '',
            };

            return errors;
        },

        getData() {
            return {
                canHide: true,
                block: 'form-layer',
                classes: this.classes,
                mods: ['form-layer', 'responsive', 'compact', 'popup'].concat(
                    this.mods || [],
                ),
                fields: this._getFields(),
                desc: this.desc,
                buttons:
                    typeof this.buttons === 'function'
                        ? this.buttons()
                        : this.buttons,
                title:
                    typeof this.title === 'function'
                        ? this.title()
                        : this.title,
                errors: this._getErrors(),
                width: this.width,
            };
        },

        recalculatePosition() {
            $(window).trigger('resize');
        },

        destroy() {
            this._el && this._el.remove();
            // eslint-disable-next-line prefer-rest-params
            BLayer.fn.destroy.apply(this, arguments);
        },
    });
});
